import { useContext, useEffect, useState } from "react";
import { ConfigContext } from "../../../../../../../../../../../contexts/ConfigContext";
import { paths } from "../../../../../../../../../../../Routes";
import { ENV_FLYWIRE_ENVIRONMENT } from "../../../../../../../../../../../config/envVars";

const FLYWIRE_LIBRARY_URL = "https://payment.flywire.com/assets/js/checkout.js";

export const useFlywire = (paymentToken, paymentPlanLineId) => {
  const {
    state: { language, region },
  } = useContext(ConfigContext);

  const [flywire, setFlywire] = useState();

  useEffect(() => {
    return () => {
      const flywireScriptEl = getFlywireScriptEl();
      if (!flywireScriptEl) return;
      document.body.removeChild(flywireScriptEl);
    };
  }, []);

  useEffect(() => {
    const flywireScriptEl = getFlywireScriptEl();
    if (!flywireScriptEl && paymentToken) {
      loadFlywire();
    }
  }, [paymentToken]);

  const loadFlywire = () => {
    const script = document.createElement("script");
    script.src = FLYWIRE_LIBRARY_URL;
    script.async = true;
    script.type = "text/javascript";
    script.addEventListener("load", () => setFlywire(window.flywire));
    document.body.appendChild(script);
  };

  useEffect(() => {
    if (flywire && paymentToken) {
      const config = {
        env: ENV_FLYWIRE_ENVIRONMENT,
        locale: `${language}-${region}`,
        provider: "embed2.0",
        token: paymentToken,
        displayPayerInformation: true,
        return_url: `${window.location.origin}${paths.CallbackFlywire}/${paymentPlanLineId}`,
      };
      flywire.Checkout.render(config, "#flywire-btn");
    }
  }, [flywire, paymentToken]);

  const getFlywireScriptEl = () =>
    Array.from(document.body.getElementsByTagName("script")).find(
      (script) => script.src === FLYWIRE_LIBRARY_URL
    );

  return { flywire, getFlywireScriptEl };
};
